// 导入自己需要的组件
import ElementUI from "element-ui";
ElementUI.Dialog.props.closeOnPressEscape.default = false
ElementUI.Dialog.props.closeOnClickModal.default = false



// WEBPACK FOOTER //
// ./src/element/index.js